export default "__VITE_ASSET__BQFlxKEE__"